<template>
    <div>
        <transition name="fade" duration="350">
            <div class="catalog-layout__content_empty" v-if="!buildings.isLoading & buildings.list.length == 0">
                <p>Нет результатов</p>
            </div>
        </transition>      
        <div class="catalog-masonry" ref="masonryGrid">
            <div class="catalog-masonry__sizer"></div>
            <div class="catalog-masonry__gutter"></div>

            <transition-group name="fade" duration="300" v-on:after-leave="updateMasonry">
                <div class="catalog-grid-item" v-for="(item, index) in buildings.list" :key="item.title">
                    <div class="img">
                        <img :src="item.thumbnail" :alt="item.title">
                    </div>
                    <div class="text">
                        <span class="title">{{item.title}}</span>
                        <span class="metro"><i :style="{'background-color': item.metro.color}"></i>{{item.metro.title}}</span>
                        <span class="price" v-if="item.meterPrice && item.meterPrice > 0">от {{item.meterPrice | threeDigits}} руб/м<sup>2</sup></span>
                    </div>
                    <a :href="item.url" class="link"></a>
                </div>
            </transition-group>
            <!--
            <div class="catalog-grid-item fullscreen">
                <div class="img">
                    <img src="/images/content/catalog/mistola-hills.png" alt="Mistola Hills">
                </div>
                <div class="text">
                    <span class="title"><span><span>Дом у Елагина острова</span></span></span>
                    <span class="location">Район красносельский</span>
                    <span class="metro"><i style="background-color: #FF0000;"></i>Девяткино</span>
                    <span class="price">от 114 435 /м<sup>2</sup></span>
                </div>
                <a href="#" class="link"></a>
            </div>
            -->
        </div>
        <transition name="fade" duration="350">
            <div class="catalog-masonry__foot" v-if="buildings.total > buildings.list.length">
                <span class="button-pill" :class="{ 'loading' : buildings.isLoading }" @click="$parent.getNextPage()">Загрузить еще</span>
            </div>
        </transition>
    </div>
</template>

<script>
    import Masonry from 'masonry-layout';
    import threeDigits from '../filters/threeDigits';

    export default {
        props: ['buildings'],
        data() {
            return {
                masonry: null
            }
        },
        methods: {
            initMasonry() {   
                this.$nextTick(() => {
                    this.preloadImages(this.buildings.list.map((item) => item.thumbnail)).then(() => {
                        this.masonry =
                            new Masonry(this.$refs.masonryGrid, {
                            itemSelector: '.catalog-grid-item',
                            columnWidth: '.catalog-masonry__sizer',
                            gutter: '.catalog-masonry__gutter',
                            percentPosition: true,
                            horizontalOrder: true,
                            isAnimated: false,
                            transitionDuration: 0
                        });                         
                    });                     
                  });                                           
            },
            updateMasonry() {
                this.$nextTick(() => {
                    this.preloadImages(this.buildings.list.map((item) => item.thumbnail)).then(() => {
                        this.masonry.reloadItems();
                        this.masonry.layout();                           
                    });                  
                });             
            },
            preloadImages(srcs) {
                function loadImage(src) {
                    return new Promise(function(resolve, reject) {
                        var img = new Image();
                        img.onload = function() {
                            resolve(img);
                        };
                        img.onerror = img.onabort = function() {
                            reject(src);
                        };
                        img.src = src;
                    });
                }
                var promises = [];
                for (var i = 0; i < srcs.length; i++) {
                    promises.push(loadImage(srcs[i]));
                }
                return Promise.all(promises);
            }
        },
        watch: {
            'buildings.list'() {
                this.updateMasonry();                       
            }
        },
        mounted() {
            this.initMasonry();
            this.$emit("grid-opened");
        },
        filters: {
            threeDigits
        }
    }
</script>